import React from 'react';
import i18n from 'i18next';
import { isIOS, isAndroid, isChrome, isMobile } from 'react-device-detect';
import { IS_IFRAME_MODE } from 'config/envVariable';
import { css } from '@emotion/core';
import Typography from '@material-ui/core/Typography';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';

function ResultDownloadBtn({ href, componentStyle }) {
    // 判斷是否為特殊情況：iOS + Chrome + iframe
    const isSpecialIOSCase = isIOS && isChrome && IS_IFRAME_MODE;

    // 判斷是否顯示下載按鈕
    // 1. Android 顯示
    // 2. 特殊情況 (iOS + Chrome + iframe) 顯示
    // 3. 非 iOS 的其他平台顯示
    const shouldShowDownloadBtn = isAndroid || isSpecialIOSCase || !isIOS;

    // 決定顯示文字
    let displayText;
    if (isMobile) {
        if (isIOS && !isSpecialIOSCase) {
            // iOS (除了特殊情況) 顯示：長按圖片儲存
            displayText = i18n.t('label.ugc.img.mobile_ios_download');
        } else {
            // Android 和特殊情況顯示：點擊下載或長按圖片儲存
            displayText = i18n.t('label.ugc.img.mobile_download');
        }
    } else {
        // 電腦版顯示：下載
        displayText = i18n.t('label.ugc.img.download');
    }

    // 處理下載功能
    const handleDownload = async e => {
        // 如果不需要特殊處理，使用默認行為
        if (!shouldShowDownloadBtn) {
            return;
        }

        // 對於需要特殊處理的情況，阻止默認行為
        e.preventDefault();

        try {
            const response = await fetch(href);
            const blob = await response.blob();

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            const filename = href.split('/').pop() || 'image.png';
            link.setAttribute('download', filename);

            document.body.appendChild(link);
            link.click();

            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
        } catch (error) {
            console.error('下載圖片時出錯:', error);
            // 如果下載失敗，回退到直接打開圖片
            window.open(href, '_blank');
        }
    };

    const renderDownloadBtn = () => {
        return (
            <div css={downloadDivStyle}>
                <ArrowUpwardIcon css={downloadIconStyle(componentStyle)} />
                <Typography variant="button" css={downloadStyle(componentStyle)}>
                    {displayText}
                </Typography>
            </div>
        );
    };

    if (isIOS && !isSpecialIOSCase) {
        return renderDownloadBtn();
    }

    return <div onClick={handleDownload}>{renderDownloadBtn()}</div>;
}

export default ResultDownloadBtn;

const downloadDivStyle = css`
    display: flex;
    cursor: pointer;
    text-decoration: none;
    color: #000000;
`;

const downloadStyle = (componentStyle = {}) => css`
    font-weight: 500;
    color: ${componentStyle.titleColor};
    word-break: break-all;
    margin-left: 13px;
`;

const downloadIconStyle = (componentStyle = {}) => css`
    color: ${componentStyle.titleColor};
`;
